import { css } from '@/styled-system/css';

export const filterChipWithMenuIconStyles = css.raw({
  color: 'icon.neutral',
  position: 'absolute',
  left: 'Chip.padding.horz',
  top: '50%',
  transform: 'translateY(-50%)',
});
